import React from 'react';
import {
  Box,
  Card,
  CardContent,
  Grid,
  Typography,
  FormControl,
  Select,
  MenuItem
} from '@mui/material';
import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, CartesianGrid } from 'recharts';
import palette from 'src/theme/palette';

const data = [
  { name: 'Property 1', views_count: 40 },
  { name: 'Property 5', views_count: 45 },
  { name: 'Property 3', views_count: 42 },
  { name: 'Property 6', views_count: 55 },
  { name: 'Property 6', views_count: 65 },
  { name: 'Property 6', views_count: 72 },
  { name: 'Property 7', views_count: 80 },
  { name: 'Property 8', views_count: 90 },
  { name: 'Property 9', views_count: 20 },
  { name: 'Property 10', views_count: 30 },
  { name: 'Property 11', views_count: 100 }
];

// Custom Tooltip (Hover Insight)
const CustomTooltip = ({ active, payload, label }) => {
  if (active && payload && payload.length) {
    const property = payload[0].payload;
    return (
      <Box
        sx={{
          backgroundColor: palette.primary.white,
          border: `1px solid ${palette.primary.inputborder}`,
          boxShadow: '0px 4px 10px rgba(0,0,0,0.1)',
          borderRadius: 1,
          p: 1.2
        }}
      >
        <Typography
          sx={{ fontFamily: 'poppinsSemiBold', fontSize: 13, color: palette.primary.titledark }}
        >
          {property?.name}
        </Typography>
        <Typography
          sx={{ fontFamily: 'poppinsRegular', fontSize: 12, color: palette.primary.title }}
        >
          {`Views & Inquiries: ${property?.views_count}`}
        </Typography>
      </Box>
    );
  }
  return null;
};

// Component
const ListingChart = ({ graph, onPeriodChange }) => {
  const [period, setPeriod] = React.useState('');

  const handleChange = (event) => {
    const selectedPeriod = event.target.value;
    setPeriod(selectedPeriod);

    if (onPeriodChange) {
      onPeriodChange(selectedPeriod);
    }
  };
  // {
  //   console.log('graph', graph);
  // }
  // console.log(graph?.data?.[0]?.name);
  // console.log(graph?.data?.[0]?.url);
  // console.log(graph?.data?.[0]?.views_count);
  return (
    <Grid item xs={12} md={12}>
      <Card
        sx={{
          borderRadius: 1,
          boxShadow: '0px 2px 10px rgba(0,0,0,0.1)',
          transition: '0.3s',
          p: 1,
          height: '100%',
          backgroundColor: palette.primary.white,
          '&:hover': {
            boxShadow: '0px 4px 12px rgba(0,0,0,0.1)',
            transform: 'translateY(-4px)'
          }
        }}
      >
        <CardContent>
          {/* Title Section */}
          <Box
            display="flex"
            flexDirection={{ xs: 'column', sm: 'row' }}
            justifyContent="space-between"
            alignItems={{ xs: 'flex-start', sm: 'center' }}
            mb={2}
            gap={2}
          >
            <Typography
              sx={{
                fontFamily: 'poppinsSemiBold',
                fontSize: 18,
                color: palette.primary.titledark
              }}
            >
              Listings Performance
            </Typography>

            <FormControl
              size="small"
              sx={{
                minWidth: 140,
                '& .MuiOutlinedInput-root': {
                  borderRadius: 1,
                  fontFamily: 'poppinsRegular'
                }
              }}
            >
              <Select
                value={period}
                onChange={handleChange}
                displayEmpty
                sx={{
                  fontSize: 13,
                  color: palette.primary.title
                }}
              >
                <MenuItem value="">Select Period</MenuItem>
                <MenuItem value="week">This Week</MenuItem>
                <MenuItem value="month">This Month</MenuItem>
                <MenuItem value="year">This Year</MenuItem>
              </Select>
            </FormControl>
          </Box>

          {/* Subtitle */}
          <Typography
            sx={{
              fontFamily: 'poppinsRegular',
              fontSize: 14,
              color: palette.primary.title,
              mb: 2
            }}
          >
            Views & Inquiries per Property
          </Typography>

          {/* Chart */}
          <Box sx={{ width: '100%', height: 250 }}>
            <ResponsiveContainer>
              <BarChart
                data={graph?.data || []}
                margin={{ top: 10, right: 10, left: 0, bottom: 0 }}
              >
                <CartesianGrid
                  strokeDasharray="3 3"
                  vertical={false}
                  stroke={palette.primary.inputborder}
                />
                {/* <XAxis
                  dataKey="name"
                  tick={{ fill: palette.primary.title, fontSize: 12 }}
                  axisLine={false}
                  tickLine={false}
                /> */}
                <YAxis
                  tick={{ fill: palette.primary.title, fontSize: 12 }}
                  axisLine={false}
                  tickLine={false}
                />
                <Tooltip content={<CustomTooltip />} cursor={{ fill: 'rgba(0,0,0,0.04)' }} />
                <Bar
                  dataKey="views_count"
                  fill={palette.primary.dark}
                  radius={[6, 6, 0, 0]}
                  barSize={40}
                  cursor="pointer"
                  onClick={(data) => {
                    if (data?.payload?.url) {
                      window.open(data?.payload?.url, '_blank');
                    }
                  }}
                />
              </BarChart>
            </ResponsiveContainer>
          </Box>
        </CardContent>
      </Card>
    </Grid>
  );
};

export default ListingChart;
